import axios from 'axios'
// import Qs from 'qs'
import store from '@/store/index'
import router from '@/router/index'
import $message from './message'
import $util from '@/utils/utils'
import $i18 from '@/utils/I18.js'
import $api from '@/api/index.js'
const fetch = axios.create({
    baseURL: process.env.VUE_APP_API_BASE
    // "Access-Control-Allow-Origin": "*" // 前端配置跨域请求头，一般配置代理
})
let requestList = new Set() // 存储请求url
fetch.interceptors.request.use(
    // 请求拦截器
    config => {
        // removePending(config)
        // config.cancelToken = new CancelToken(c => {
        //   pending.push({
        //     u: config.url + '&' + config.method,
        //     f: c
        //   })
        // })
        let acctssToken = localStorage.getItem("accessToken")
        config.headers.language = localStorage.getItem("language") || 'zh'
        config.headers.website = $util.getCurrentWebSite();
        config.headers.unionKey = 'gt6';
        if (acctssToken) {
            if (!config.notHaveToken) config.headers.Authorization = acctssToken
            if (config.url.indexOf('business') === 0) {
                if (config.data) {
                    config.data.token = acctssToken
                } else {
                    config.data = {
                        token: acctssToken
                    }
                }
            }
        }
        // 利用cancelToken 取消当次请求
        // config.cancelToken = new axios.CancelToken(c => {
        //     // 在这里阻止重复请求，上个请求未完成时，相同的请求不会再次执行
        //     requestList.has(`${config.url}&${config.method}`) ? c(`${location.host}${config.url}---重复请求被中断`) : requestList.add(`${config.url}&${config.method}`)
        // })
        return config
    },
    error => {
        // fundebug.notify(error)
        return Promise.reject(error)
    }
)
fetch.interceptors.response.use(
    response => {
        let { url, method } = response.config
        // 相同请求不得在600毫秒内重复发送，反之继续执行
        // setTimeout(() => {
        //     requestList.delete(`${url}&${method}`)
        // }, 600)
        const res = response.data
        // let resFileName=response.headers.Content-Disposition
        if (response.headers.hasOwnProperty('content-disposition')) {
            let resFileName = response.headers['content-disposition'].split('=')[1]
            store.commit('report_name', decodeURIComponent(resFileName))
        }
        res.code = Number(res.code)
        if (res.code !== 200) {
            // 401: 登录过期或token失效  403: 权限不足  500: 系统内部错误
            switch (res.code) {
                case 401:
                    let log = sessionStorage.getItem('webLog')
                    if(log) {
                        log = JSON.parse(log)
                    } else {
                        log = {}
                    }
                    log = {...log, timeOnPage:  Date.now(), attribute: `ajax-web-config:${JSON.stringify({...response.config, code: res.code})}`}
                    $api.logs.addWebLogs(log)
                    if (!window.logoutTimeoutSet) {
                        window.logoutTimeoutSet = true;
                    setTimeout(()=>{
                        window.localStorage.clear();
                        window.sessionStorage.clear();
                        window.logoutTimeoutSet = false;
                        if (router.history.current.fullPath.toLowerCase().indexOf('/login') >= 0) {
                            localStorage.setItem("isLogOut", true);
                        }
                        $util.loginOutUrl(router.history.current.fullPath);
                    }, 500)
                    }
                    break
                case 500:
                    // fundebug.notify(res)
                    $message({
                        message: $i18.language('当前您的网络环境不稳定，请检查您的网络环境或重新刷新此页面。'),
                        type: 'warning',
                        duration: 5 * 1000
                    })
                    break
                case 1002:
                    console.log(router)
                    // fundebug.notify(res)
                    router.push({ name: 'error', query: { msg: res.msg } })
                    break
                default:
                    localStorage.removeItem("isLogOut");
                    if (res.code) {
                        if(res.code!==201){
                            $message({
                                message: res.msg ? res.msg : res.code + '-' + $i18.language('系统繁忙'),
                                type: 'warning',
                                duration: 1000 * 5
                            })
                        }
                        return response.data
                    } else {
                        return response.data
                    }


            }
            return Promise.reject(res)
        } else {
            return response.data
        }
    },
    error => {
        if (axios.isCancel(error)) {
        } else {
            // 请求如果失败了，务必从列表里面删掉，否则请求拦截器会取消请求
            // const key = `${error.config.url}&${error.config.method}`
            // requestList.delete(key)
            if (error.response && error.response.status === 401) {
                window.localStorage.clear();
                window.sessionStorage.clear();
                localStorage.setItem("isLogOut", true);
                $util.loginOutUrl(router.history.current.fullPath);
            } else {
                // fundebug.notify(error)
                $message({
                    message: $i18.language('当前您的网络环境不稳定，请检查您的网络环境或重新刷新此页面。'),
                    type: 'warning',
                    duration: 5 * 1000
                })
            }
        }
        return Promise.reject(error)
    }
)

export default fetch
